import {  TeamsResponseModel } from "@gtpl/shared-models/hrms";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Controller, Post, Body } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { TeamDto } from "./dtos/teams.dto";
import { TeamRequest } from "./dtos/teams.request";
import { UserRequestDto } from "./dtos/user-request-dto";
import { TeamsService } from "./teams.service";

@ApiTags('teams')
@Controller('teams')
export class TeamController {
    constructor(
        private service: TeamsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createTeam')
    async createTeam(@Body() dto: TeamDto, isUpdate: boolean = false): Promise<TeamsResponseModel>{
        try{
            return await this.service.createTeam(dto, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TeamsResponseModel, error);
        }
    }

    @Post('/updateTeam')
    async updateTeam(@Body() dto: TeamDto, isUpdate: boolean = false): Promise<TeamsResponseModel>{
        try{
            return await this.service.createTeam(dto, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TeamsResponseModel, error);
        }
    }

    
    @Post('/getAllTeams')
    async getAllTeams(@Body() req?:UserRequestDto): Promise<TeamsResponseModel>{
        try{
            return await this.service.getAllTeams(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TeamsResponseModel, error);
        }
    }

    @Post('/getAllActiveTeams')
    async getAllActiveTeams(): Promise<TeamsResponseModel>{
        try{
            return await this.service.getAllActiveTeams();
        }catch(error){
            return this.applicationExceptionHandler.returnException(TeamsResponseModel, error);
        }
    }

    
    @Post('/activateOrDeactivateTeams')
    async activateOrDeactivateTeams(@Body() temReq: TeamRequest): Promise<TeamsResponseModel>{
        try{
            return await this.service.activateOrDeactivateTeams(temReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TeamsResponseModel, error);
        }
    }

}